module.exports = __webpack_public_path__ + "static/media/02 Generali Auto Karta produktu.4702beb5.pdf";